import { encodeArk } from '@fs/zion-ark'
import { getApidImageUrl } from '../services/das/dasService'

export const getImagesFromApidList = (apidList) => {
  return (
    apidList
      // First, filter out any APIDs containing 'tomato'
      .filter((apid) => !apid.toLowerCase().includes('tomato'))
      .map((apid, i) => {
        try {
          return {
            srcSet: {
              0: getApidImageUrl(apid, 'thumb_p200.jpg'),
              500: getApidImageUrl(apid, 'image.xml'),
            },
            alt: apid,
            id: apid,
            ark: encodeArk(apid),
            index: i,
          }
        } catch (error) {
          // If encoding fails, log the error and return null
          console.error(`Failed to encode ARK for APID: ${apid}`, error)
          return null
        }
      })
      .filter((image) => image !== null)
  )
}
